module.exports = __webpack_public_path__ + "img/20210625_120001.540eb818.jpg";